import React from 'react' 
import Profile from '../pages/Profile'
import UpdatePassword from '../pages/auth/LoginForm/Components/UpdatePassword'
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword.jsx'
import ManagePatients from '../pages/ManagePatient/index.jsx'
import ViewPatient from '../pages/ManagePatient/ViewPatient/index.jsx'
import ContactHistory from '../pages/ManagePatient/ViewPatient/Components/ContactHistory/contactHistory.jsx'
import PatientIndex from '../pages/ManagePatient/ViewPatient/Components/EditMonitorConditions/index.jsx'
import ManagePatientActivityHistory from '../pages/ManagePatient/ManagePatientActivityHistory/Index.jsx'
import ManageDashboardPatients from '../pages/ManageDashboard/index.jsx'
import ViewProvider from '../pages/ManageDashboard/ViewProvider/index.jsx'
import ManageAlerts from '../pages/ManageAlerts/index.jsx'
import ManageWellnessReports from '../pages/Reports/WellnessReports/index.jsx'
import AlertReport from '../pages/Reports/WellnessReports/AlertReport/index.jsx'
import BloodGlouseVitalList from '../pages/ManagePatient/ViewPatient/ViewVitalHistory/index.jsx'
import ManageUploadFile from '../pages/ManageTransferFile/index.jsx'

export const ComponentsBasedOnRole = {
    "provider": 
    [
        {
            name : 'Profile',
            element : <Profile />,
            path : '/profile',
            roleKey : 'Profile',
        },
        {
            name : 'Reset',
            element :  <ResetPassword />,
            path : '/reset',
            roleKey : 'Reset',
        },
        {
            name:'Update Password',
            element:<UpdatePassword />,
            path:'/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name:'Manage Patients',
            element:<ManagePatients/>,
            path:'/manage-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-patients/view-patient/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ContactHistory />,
            path:'/manage-patients/view-patient/contact-history/:id/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex edit/>,
            path:'/manage-patients/edit-patient/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientActivityHistory/>,
            path:'/manage-patients/activity_history',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Alerts',
            element:<ManageAlerts />,
            path:'/alerts-notifications',
            roleKey : 'Manage-Alerts'
        },
        {
            name:'Manage Patient',
            element:<ViewProvider/>,
            path:'/manage-patients/provider-list/:id/:patient_id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patient',
            element:<ManageWellnessReports/>,
            path:'/reports/wellness-report',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Patient',
            element: <AlertReport/>,
            path : '/reports/alert-report',
            roleKey : 'Manage-Patient'
        },
        {
            name  : 'Upload File',
            element: <ManageUploadFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },

        
        
    ],
    "monitor-user":
    [
        {
            name : 'Profile',
            element : <Profile />,
            path : '/profile',
            roleKey : 'Profile',
        },
        {
            name : 'Reset',
            element :  <ResetPassword />,
            path : '/reset',
            roleKey : 'Reset',
        },
        {
            name:'Update Password',
            element:<UpdatePassword />,
            path:'/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name:'Manage Patients',
            element:<ManagePatients/>,
            path:'/manage-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-patients/view-patient/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-dashboard/view-patient/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ContactHistory />,
            path:'/manage-patients/view-patient/contact-history/:id/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex edit/>,
            path:'/manage-patients/edit-patient/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name:'Manage Patients',
            element:<ManagePatientActivityHistory/>,
            path:'/manage-patients/activity_history',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Dashboard',
            element:<ManageDashboardPatients/>,
            path:'/manage-dashboard',
            roleKey : 'Manage-Dashboard'
        },
        {
            name:'Manage Dashboard',
            element:<ViewProvider/>,
            path:'/manage-dashboard/provider-list/:id/:patient_id',
            roleKey : 'Manage-Dashboard'
        },
        {
            name:'Manage Patient',
            element:<ViewProvider/>,
            path:'/manage-patients/provider-list/:id/:patient_id',
            roleKey : 'Manage-Patients'
        },
        
        {
            name:'Manage Patient',
            element:<ManageWellnessReports/>,
            path:'/reports/wellness-report',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Patient',
            element: <AlertReport/>,
            path : '/reports/alert-report',
            roleKey : 'Manage-Patient'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList device/>,
            path:'/manage-patients/view-patient/:id/vital-history/device/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Upload File',
            element: <ManageUploadFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },

        
    ]
}